import { useState } from "react";

export default function Image({ className, src, alt }) {
   const [loaded, setLoaded] = useState(false);

   return (
      <div className={`${className} inline-block aspect-square ${loaded ? '' : 'bg-gray-200'}`}>
         <img
            src={src}
            alt={alt}
            className={`w-full h-full ${loaded ? '' : 'hidden'}`}
            onLoad={() => setLoaded(true)}
         />
      </div>
   );
}
